import { IImageLeafParagraph, ImageLeafParagraphProps } from './types';

export const mapImageLeafParagraph = ({
  prismicContent,
}: {
  prismicContent: ImageLeafParagraphProps['slice'];
}): IImageLeafParagraph => {
  const {
    large_title: largeTitle,
    image: { url: image, alt },
    picture_on_right: hasPictureOnRight,
  } = prismicContent.primary;
  const imageLeafParagraph = {
    ...prismicContent.primary,
    largeTitle,
    image: image as string,
    alt: alt as string,
    hasPictureOnRight,
  };

  return imageLeafParagraph;
};
